import { createAsyncThunk } from '@reduxjs/toolkit'
import GameMetric from './game-metric-model'
import {
  delete_gameMetric,
  load_gameMetrics,
  store_gameMetric,
} from './gameMetric-service'

export const LoadGameMetricsAsync = createAsyncThunk<any, any>(
  'composer/load/gameMetric',
  async (params: { uid: string }) => {
    return await load_gameMetrics(params)
  },
)

export const CreateGameMetricAsync = createAsyncThunk<any, any>(
  'composer/create/gameMetric',
  async (params: GameMetric) => {
    return await store_gameMetric(params)
  },
)

export const DeleteGameMetricAsync = createAsyncThunk<any, any>(
  'composer/delete/gameMetric',
  async (params) => {
    return await delete_gameMetric(params)
  },
)
